import { useQuery } from '@tanstack/react-query';
import api from '../api/api';
import { queryKeys } from './queryKeys';

export const useEvent = (id) => {
  return useQuery({
    queryKey: queryKeys.events.detail(id),
    queryFn: async () => {
      const response = await api.get(`/events/${id}`);
      return response.data?.data || response.data;
    },
    enabled: !!id,
  });
};
